const URL_FUNCTIONS = "https://us-central1-gnp-agenda-prod.cloudfunctions.net";
const URL_SERVICES = "https://servicios-gipa-dot-gnp-agenda-prod.appspot.com/api/prod";

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDTw-azkgrz-9jNs8DUFwY5NxgAMEfT9QA",
    authDomain: "gnp-agenda-prod.firebaseapp.com",
    databaseURL: "https://gnp-agenda-prod.firebaseio.com",
    projectId: "gnp-agenda-prod",
    storageBucket: "gnp-agenda-prod.appspot.com",
    messagingSenderId: "266589068901",
    //appId: "1:552289166103:web:c53929c74ffd385a884d52",
    //measurementId: "G-TD3TW0XG85",
  },
  entradas: {
    cargar: `${URL_FUNCTIONS}/entradasV2/buscarEntradas`,
    relacionados: `${URL_FUNCTIONS}/entradasV2/relacionados`,
    consultarAcuerdoPorEntrada: `${URL_SERVICES}/despacho/consultarAcuerdoPorEntrada`,
    treeMap: `${URL_FUNCTIONS}/jerarquiaV2/tree`,
    eliminar: `${URL_FUNCTIONS}/jerarquiaV2/eliminar`,
  },
  usuarios: {
    nuevo: `${URL_FUNCTIONS}/usuariosV2/nuevo`,
    actualizar: `${URL_FUNCTIONS}/usuariosV2/actualizar`,
    borrar: `${URL_FUNCTIONS}/usuariosV2/borrar`,
    rol: `${URL_FUNCTIONS}/usuariosV2/rol`,
    actualizarMostrar: `${URL_FUNCTIONS}/usuariosV2/actualizarMostrar`,
  },
  folio: {
    genera: `${URL_FUNCTIONS}/foliadorV2/generarFolio`,
  },
  catalogos: {
    getCatalogo: `${URL_SERVICES}/acuerdos/getCatalogo/`,
    consultaResponsables: `${URL_SERVICES}/acuerdos/getResponsablesFB`,
    formasEnvio: `${URL_SERVICES}/acuerdos/getCatFormaEnvio`,
    consultaResponsablesAll: `${URL_SERVICES}/acuerdos/getAllResponsablesFB`,
  },
  apiSearch: {
    busqueda: `${URL_FUNCTIONS}/apisearch/busqueda`,
    busquedaAvanzada: `${URL_FUNCTIONS}/apisearch/busquedaAvanzada`,
  },
  despacho: {
    consultarTemas:`${URL_SERVICES}/despacho/consultarTemas`,
    guardarTema:`${URL_SERVICES}/despacho/guardarTema`,
    relacionarEntrada:`${URL_SERVICES}/despacho/relacionarEntradaTemaDespacho`,
    terminarTema: `${URL_SERVICES}/despacho/terminarTemaDespacho`,
    cancelarEntregables: `${URL_SERVICES}/despacho/cancelarEntregables`,
    terminarEntregables: `${URL_SERVICES}/despacho/terminarEntregables`,
    terminarSeguimiento: `${URL_SERVICES}/despacho/terminarSeguimiento`,
    listarEntregables: `${URL_SERVICES}/despacho/listarEntregables`,
    listarEntregablesEnviadosAEjecucion: `${URL_SERVICES}/despacho/listarEntregablesEnviadosAEjecucion`,
    listarEntradasConSeguimiento: `${URL_SERVICES}/despacho/listarEntradasConSeguimiento`,
    
    consultarTemasDespachoBeta: `${URL_SERVICES}/despacho/consultarTemasDespachoBeta`,
    agregarTemaDespacho: `${URL_SERVICES}/despacho/agregarTemaDespacho`,
    consultarTemaAMover: `${URL_SERVICES}/despacho/consultarTemaAMover`,
    moverTemaDespachoAcuerdoMrB: `${URL_SERVICES}/despacho/moverTemaDespachoAcuerdoMrB`,
    getExcelEmpresas: `${URL_SERVICES}/despacho/getExcelEmpresas`,
    getExcelInfoVoBo: `${URL_SERVICES}/despacho/getExcelInfoVoBo`,
    getExcelEmpresa: `${URL_SERVICES}/despacho/getExcelEmpresa`,
    getExcelSeleccion: `${URL_SERVICES}/despacho/getExcelSeleccion`,
    getInfoDespacho: `${URL_SERVICES}/despacho/getInfoDespacho`,
    editarTemas: `${URL_SERVICES}/despacho/editarTemas`,
    consultarTemasPorEmpresa: `${URL_SERVICES}/despacho/consultarTemasPorEmpresa`,
    quitarTema: `${URL_SERVICES}/despacho/quitarTema`,
  },
  acuerdos: {
    agregarAcuerdo: `${URL_SERVICES}/acuerdos/agregarAcuerdo`,
    consultarAcuerdos: `${URL_SERVICES}/acuerdos/consultarAcuerdos`,
    agregarIndicacionesAB: `${URL_SERVICES}/acuerdos/agregarIndicacionesAB`,
    buscarEntradas: `${URL_SERVICES}/acuerdos/buscarEntradas`,
    notificacion: `${URL_SERVICES}/acuerdos/notificarMensajes`,
    editarAcuerdo: `${URL_SERVICES}/acuerdos/editarAcuerdo`,
    consultaEntregables: `${URL_SERVICES}/acuerdos/consultarEntregables`,
    relacionarEntrada: `${URL_SERVICES}/acuerdos/relacionarEntrada`,
    guardarTema: `${URL_SERVICES}/acuerdos/guardarTema`,
    consultarTerminar: `${URL_SERVICES}/acuerdos/consultarJustificacionTerminarTema`,
    terminarTema: `${URL_SERVICES}/acuerdos/terminarTema`,
    aplazarTema: `${URL_SERVICES}/acuerdos/aplazarTema`,
    eliminarEntrada: `${URL_SERVICES}/acuerdos/eliminarEntrada`,
    exportAcuerdos: `${URL_SERVICES}/acuerdos/exportAcuerdos`,
    detalleAcuerdoMR: `${URL_SERVICES}/acuerdos/detalleAcuerdoMR`,
    consultaFechasAcuerdo: `${URL_SERVICES}/acuerdos/consultaFechasAcuerdo`,
    descargaArchivosAcuerdo: `${URL_FUNCTIONS}/descargaV2/acuerdo`,
    moverTemaAcuerdoMrBDespacho: `${URL_SERVICES}/acuerdos/moverTemaAcuerdoMrBDespacho`,
    consultarArchivosPorEntrada: `${URL_SERVICES}/acuerdos/consultarArchivosPorEntrada`,
    exportBitacoraObservaciones: `${URL_SERVICES}/acuerdos/exportBitacoraObservaciones`,
    eliminarArchivoAdjunto : `${URL_FUNCTIONS}/acuerdos/eliminarArchivoAdjunto`,
    categoria: `${URL_SERVICES}/acuerdos/getCatalogo/CATEGORIA`,
    getListaTemas: `${URL_SERVICES}/acuerdos/getListaTemas`,
  },
  temas: {
    descargar: `${URL_FUNCTIONS}/descarga/temas`,
  },
  entregables: {
    gas: `https://script.google.com/a/macros/gnp.com.mx/s/AKfycbzHh9or_VZ7RVoE3RZHnbXadpqFQubDDoa7IEoNiD46COTdRhb6ilYxOE45WkXLenmn/exec`,
    bitacora: `${URL_FUNCTIONS}/entregablesV2/bitacora`,
    obtener: `${URL_FUNCTIONS}/entregablesV2/obtener`,
    descarga: `${URL_FUNCTIONS}/entregablesV2/entregable`,
  },
  reportes: {
    consulta: `${URL_FUNCTIONS}/reportesV2/consulta`,
    descarga: `${URL_FUNCTIONS}/reportesV2/descarga`,
  },
  tablero: {
    estatus: `${URL_FUNCTIONS}/tableroV2/obtener`,
    descarga: `${URL_FUNCTIONS}/tableroV2/descarga`,
  },
  notificaciones: {
    create: `${URL_FUNCTIONS}/notificaciones/create`
  },
  user_supervisor: 'tT03HnZ3pGWabzX4xRXUzLs9txf2'
};
